export enum OWNER_TYPES {
  BUILDING = 'building',
  COMPANY = 'company',
  BUILDING_COMPANY = 'building_company',
}
